export const WizardGender = {
  Man: 'man',
  Woman: 'woman'
}
